import { _ as _getTag } from './_getTag.mjs';
import { i as isObjectLike_1 } from './isObjectLike.mjs';

var getTag = _getTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

var _baseIsMap = baseIsMap;

export { _baseIsMap as _ };
